/**
 * Форматирует длительность в секундах: `M:SS`, при наличии часов — `H:MM:SS`.
 */
export function formatDuration(totalSeconds: number): string {
  const safe = Math.max(0, Math.floor(totalSeconds))
  const hours = Math.floor(safe / 3600)
  const minutes = Math.floor((safe % 3600) / 60)
  const seconds = safe % 60
  const ss = String(seconds).padStart(2, '0')
  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, '0')}:${ss}`
  }
  return `${minutes}:${ss}`
}

/**
 * Часть до двоеточия и часть после — для раздельной вёрстки таймера (часы/минуты | секунды).
 */
export function splitDuration(totalSeconds: number): { head: string; seconds: string } {
  const formatted = formatDuration(totalSeconds)
  const idx = formatted.lastIndexOf(':')
  return { head: formatted.slice(0, idx), seconds: formatted.slice(idx + 1) }
}
